import React from 'react';
import ProjectListContainer from '../../../Componant/Project/ProjectList';

const ProjectList = () => {
  return (
    <div className='page-body'>
      <ProjectListContainer />
    </div>
  );
};

export default ProjectList;
